<template>
  <v-card class="main-content-card" flat >
    <v-toolbar flat>
      <v-toolbar-title>合作协议报审</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="primary" class="white--text"
             :disabled="!funcIds.includes('c_contract')"
             @click.native.stop="() => { editDbid = null; edit = true; }">
        <v-icon dark small>mail</v-icon>协议报审
      </v-btn>

      <v-spacer></v-spacer><!-- 让后面文字内容靠右 -->
      <span class="body-2 font-weight-bold font-italic margin-left: 16px;">（注：由科研经费支出的合同和合同审批表报审请使用"科研合同-合同填报"功能！）</span>

    </v-toolbar>

    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <v-text-field
                label="合作协议名称"
                v-model="form.name"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm4>
              <v-text-field
                label="负责人"
                v-model="form.leaderName"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm4>
              <v-menu
                ref="refApplDateStart"
                :close-on-content-click="false"
                v-model="menuApplDateStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="form.applDateStart"
                  label="申请时间(起始)"
                  clearable
                  :rules="rules.startDate"
                  hint="格式YYYY-MM-DD, 如：2018-10-01"
                  persistent-hint
                />
                <v-date-picker
                  v-model="applDateStart"
                  locale="zh-cn"
                  @change="nv => form.applDateStart= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4>
              <v-menu
                ref="refApplDateEnd"
                :close-on-content-click="false"
                v-model="menuApplDateEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="form.applDateEnd"
                  label="申请时间(截止)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD, 如：2018-10-01"
                  persistent-hint
                />
                <v-date-picker
                  v-model="applDateEnd"
                  locale="zh-cn"
                  @change="nv => form.applDateEnd= nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4>
              <v-select
                item-text="name"
                item-value="dbid"
                :items="deptItems"
                v-model="form.deptId"
                label="归属部门"
                hide-details
                clearable
              />
            </v-flex>

            <v-flex xs12>
              <span>审核状态：</span>
              <v-btn-toggle
                v-model="form.statusId"
                class="transparent"
                style="background:none;box-shadow:none"
              >
                <v-btn value="" flat>全部</v-btn>
                <v-btn flat v-for="s in statusItems" :key="s.dbid" :value="s.identifier">{{s.name}}</v-btn>
              </v-btn-toggle>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>

    <v-data-table
      :headers="headers"
      :loading="loading"
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>
          <span style="font-weight: bold">{{ props.item.name }}</span>
        </td>

        <td>
          <span style="font-weight: bold">{{ props.item.department.name}}</span>
          <br>
          {{ props.item.leaderName }} {{ props.item.leaderPhone }}
        </td>

        <td>
          {{ props.item.client}}
        </td>

        <td>
          {{ props.item.applDate | datetime}}
        </td>

        <td>
          <a target="_blank" @click.stop="printDisabled(props.item) ? $event.preventDefault() : downloadSealPdf(props.item.dbid)">
            <v-chip small
                    label
                    dark
                    class="mr-1"
                    :class="{ 'disabled-chip': printDisabled(props.item) }"
                    :color="printDisabled(props.item) ? 'grey' : 'green'"
                    :disabled = "printDisabled(props.item)">
              用印单
            </v-chip>
          </a>

          <a target="_blank" @click.stop="printDisabled(props.item) ? $event.preventDefault() : onDownload(props.item.dbid)">
            <v-chip small
                    label
                    dark
                    class="mr-1"
                    :class="{ 'disabled-chip': printDisabled(props.item) }"
                    :color="printDisabled(props.item) ? 'grey' : 'primary'"
                    :disabled = "printDisabled(props.item)">
              合同审批表
            </v-chip>
          </a>

          <!--<v-btn
              v-if="(props.item.prinSealNum || props.item.instSealNum)"
              :disabled="!(props.item.statusId==='checked')"
              small depressed class="ml-1"
              color="teal"
              @click.stop="downloadSealPdf(props.item.dbid)">
            用印单
          </v-btn>-->

          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="showHistory(props.item)">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>

          <!--<v-btn
              small depressed class="ml-1"
              color="orange"
              @click="() => { submitDbid=props.item.dbid; submitMsg=props.item.name; seal = true; }">
            填写用印单
          </v-btn>-->
        </td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { editDbid = props.item.dbid; edit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { rowIdx = props.index; submitDbid = props.item.dbid; submitMsg = props.item.name; submit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">publish</v-icon>
            </v-btn>
            <span>提交</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="pink">delete_forever</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-submit
      v-model="submit"
      :dbid="submitDbid"
      :message="submitMsg"
      :uri="uri"
      @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

    <x-history
      v-model="hist"
      :history="history"
      :status="statusItems"
    />

    <x-seal
        v-model="seal"
        :dbid="submitDbid"
        :message="submitMsg"
        :uri="uri"
        @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

    <downloader
        v-model="down"
        :url="downUrl"
        message="下载合同审批表"
        @ok="()=> {down = false}"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XView from './View'
  import XEdit from './Edit'
  import XSeal from './Seal'

  import XDelete from '@/components/global/Delete'
  import XSubmit from '@/components/global/Submit'
  import XHistory from '@/components/agmt/AgmtHistory'
  import Downloader from "@/components/global/Downloader.vue";

  import mixin from '@/mixin'

  const baseUri = '/api/agmt/agreement';
  const statusUri = '/api/code/status';
  const deptUri = '/api/syst/department';

  export default {
    // 混入模块列表页面（index）基本功能
    mixins: [mixin.index(`${baseUri}/by/request/user`)],

    components: {XView, XEdit, XSubmit, XDelete, XHistory, XSeal, Downloader},

    data() {
      return {
        uri: baseUri,

        // 检索、分页、排序条件条件
        query: {
          statusId: '',
          name: '',
          leaderName: '',
          applDateStart: '',
          applDateEnd: '',
          deptId: '',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },

        // 检索框
        form: {
          statusId: '',
          name: '',
          leaderName: '',
          applDateStart: '',
          applDateEnd: '',
          deptId: '',
        },

        statusItems: [],

        deptItems: [],

        menuApplDateStart: false,
        applDateStart: null,

        menuApplDateEnd: false,
        applDateEnd: null,

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '合作协议名称', align: 'left', sortable: true, value: 'name'},
          {text: '归属部门 / 负责人', align: 'left', sortable: true, value: 'deptId'},
          {text: '合作单位', align: 'left', sortable: true, value: 'client'},
          {text: '报审日期', align: 'left', sortable: true, value: 'applDate'},
          {text: '状态', align: 'left', sortable: true, value: 'status'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],

        properties: {
          "wt": '委托合同',
          "ww": '外委合同'
        },

        rowIdx: null,

        down: false,
        downUrl: null,

        view: false,
        viewDbid: null,

        submit: false,
        submitDbid: null,
        submitMsg: null,

        edit: false,
        editDbid: null,

        dele: false,
        deleDbid: null,
        deleMsg: null,

        hist: false,
        history: [],

        seal: false,

        rules: {
          startDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpDate().test(v) || '日期格式错误'
          ],
          endDate: [
            v => !!v || "必填项。",
            v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
            v => (v && v > this.form.applDateStart) || "截止日期必须晚于起始日期。"
          ]
        }
      }
    },

    created() {
      // 加载审核状态
      const agmturl = '/api/code/status/agmt/';
      this.axios.all([
        this.axios.get(agmturl, {params: {sort: 'rank.asc'}}),
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          (rspStaus, rspDept) => {
            this.statusItems = rspStaus.data.items;
            window.console.log(this.statusItems)
            this.deptItems = rspDept.data.items;
          }
        )
      )
    },

    computed: {
      ...mapGetters(['funcIds'])
    },

    methods: {
      downloadSealPdf(dbid) {
        // window.console.log("sealPdfUrl");
        const url = `${baseUri}/seal/${dbid}`
        const urlWithToken =  window.xutil.buildUrl(url, {})
        window.open(urlWithToken, "__blank")
      },

      onDownload(it) {
        this.downUrl = `/api/agmt/print/export/pdf/seal/${it}`
        this.down = true
      },

      // 检索响应函数
      onSearch() {
        //此段代码解决状态为全部但不显示数据的问题
        if (this.form.statusId === 0) {
          this.form.statusId = ''
        }
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.doRoute(this.query);
      },
      submitDisabled(item) {
        return !(
          // 当前用户拥有提交功能
          this.funcIds.includes('c_contract')
          // 并且，当前记录需要提交
          && item.actions.find(a => a.action === 'submit'))
      },

      printDisabled(item) {
        return !(
            item.statusId  === 'checked')
      },

      showHistory(item) {
        //this.history = item.history;
        this.history = JSON.parse(JSON.stringify(item.history));
        this.hist = true;
      }
    }
  }
</script>
